import { userLogin, userInfo } from '@/service/http.js'
import { sendErrorLog } from '@/utils/common.js'
import store from '@/store'

const state = {
    hasLogin: false,
    showGuid: false,
    userInfo: {},
    id: null
}

const mutations = {
    SET_USERDATA(state, val) {
        console.log('设置用户:', val)
        if (val) {
            state.hasLogin = true
            state.userInfo = val
            state.id = val.id
        } else {
            state.hasLogin = false
            state.userInfo = ''
            state.id = ''
        }
    },
    SET_SHOWGUI(state, val) {
        state.showGuid = val
    },
    SET_ISLOGIN(state, val) {
        state.hasLogin = val
    }
}

const actions = {
    /**
   * 登录
   */
    login({ commit }, param) {
        return new Promise((resolve, reject) => {
            userLogin(param).then(res => {
                console.log('查询用户', res)
                if (res.code === 200) {
                    commit('SET_USERDATA', res.data)
                    commit('SET_ISLOGIN', true)
                    store.dispatch('wallet/loadAccount').then(() => {
                        return resolve(true)
                    }).catch(e => {
                        sendErrorLog('[user.js-userLogin]' + e)
                        return reject(e)
                    })
                } else {
                    commit('SET_USERDATA', '')
                    commit('SET_ISLOGIN', false)
                    return reject(res.pagePrompt)
                }
            })
        })
    },
    /**
   * 无秘登录（查询用户信息）
   */
    loginWithId({ commit }, uid) {
        return new Promise((resolve, reject) => {
            userInfo({ id: uid }).then(res => {
                console.log('查询用户:', res)
                if (res.code === 200 && res.data) {
                    commit('SET_USERDATA', res.data)
                    commit('SET_ISLOGIN', true)
                    store.dispatch('wallet/loadAccount').then(() => {
                        return resolve(true)
                    }).catch(e => {
                        sendErrorLog('[user.js-userInfo]' + e)
                        return reject(e)
                    })
                } else {
                    commit('SET_USERDATA', '')
                    commit('SET_ISLOGIN', false)
                    return reject('登录失败')
                }
            })
        })
    },

    /**
   * 退出登录
   */
    logout({ commit }) {
        store.dispatch('app/clearTask')
        store.dispatch('wallet/clearOut')
        commit('SET_USERDATA', '')
        commit('SET_ISLOGIN', false)
        console.log('完成退出')
    }
}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js